var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSchooltrack1Svg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_51422",
    x: 0,
    y: 0,
    width: 72,
    height: 72,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#79266a",
    floodOpacity: 0.141,
    result: "color"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1,
    x2: 0.088,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b23a9c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#79266a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 1,
    x2: 0,
    y2: 0.807,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_35848",
    "data-name": "Group 35848",
    transform: "translate(-50 -98)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_31148",
    "data-name": "Group 31148",
    transform: "translate(49.732 97.732)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-type": "innerShadowGroup"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0.27, 0.27)",
    filter: "url(#Path_51422)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_51422-2",
    "data-name": "Path 51422",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36,0A36,36,0,1,1,0,36,36,36,0,0,1,36,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 36 1 C 31.27458953857422 1 26.69105911254883 1.925247192382812 22.37673187255859 3.75006103515625 C 18.20906829833984 5.512832641601562 14.46591949462891 8.036598205566406 11.25125885009766 11.25125885009766 C 8.036598205566406 14.46591949462891 5.512832641601562 18.20906829833984 3.75006103515625 22.37673187255859 C 1.925247192382812 26.69105911254883 1 31.27458953857422 1 36 C 1 40.72541046142578 1.925247192382812 45.30894088745117 3.75006103515625 49.62326812744141 C 5.512832641601562 53.79093170166016 8.036598205566406 57.53408050537109 11.25125885009766 60.74874114990234 C 14.46591949462891 63.96340179443359 18.20906829833984 66.48716735839844 22.37673187255859 68.24993896484375 C 26.69105911254883 70.07475280761719 31.27458953857422 71 36 71 C 40.72541046142578 71 45.30894088745117 70.07475280761719 49.62326812744141 68.24993896484375 C 53.79093170166016 66.48716735839844 57.53408050537109 63.96340179443359 60.74874114990234 60.74874114990234 C 63.96340179443359 57.53408050537109 66.48716735839844 53.79093170166016 68.24993896484375 49.62326812744141 C 70.07475280761719 45.30894088745117 71 40.72541046142578 71 36 C 71 31.27458953857422 70.07475280761719 26.69105911254883 68.24993896484375 22.37673187255859 C 66.48716735839844 18.20906829833984 63.96340179443359 14.46591949462891 60.74874114990234 11.25125885009766 C 57.53408050537109 8.036598205566406 53.79093170166016 5.512832641601562 49.62326812744141 3.75006103515625 C 45.30894088745117 1.925247192382812 40.72541046142578 1 36 1 M 36 0 C 55.88224792480469 0 72 16.11774826049805 72 36 C 72 55.88224792480469 55.88224792480469 72 36 72 C 16.11774826049805 72 0 55.88224792480469 0 36 C 0 16.11774826049805 16.11774826049805 0 36 0 Z",
    stroke: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Path_51422-3",
    "data-name": "Path 51422",
    transform: "translate(0.268 0.268)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36,0A36,36,0,1,1,0,36,36,36,0,0,1,36,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 36 1 C 31.27458953857422 1 26.69105911254883 1.925247192382812 22.37673187255859 3.75006103515625 C 18.20906829833984 5.512832641601562 14.46591949462891 8.036598205566406 11.25125885009766 11.25125885009766 C 8.036598205566406 14.46591949462891 5.512832641601562 18.20906829833984 3.75006103515625 22.37673187255859 C 1.925247192382812 26.69105911254883 1 31.27458953857422 1 36 C 1 40.72541046142578 1.925247192382812 45.30894088745117 3.75006103515625 49.62326812744141 C 5.512832641601562 53.79093170166016 8.036598205566406 57.53408050537109 11.25125885009766 60.74874114990234 C 14.46591949462891 63.96340179443359 18.20906829833984 66.48716735839844 22.37673187255859 68.24993896484375 C 26.69105911254883 70.07475280761719 31.27458953857422 71 36 71 C 40.72541046142578 71 45.30894088745117 70.07475280761719 49.62326812744141 68.24993896484375 C 53.79093170166016 66.48716735839844 57.53408050537109 63.96340179443359 60.74874114990234 60.74874114990234 C 63.96340179443359 57.53408050537109 66.48716735839844 53.79093170166016 68.24993896484375 49.62326812744141 C 70.07475280761719 45.30894088745117 71 40.72541046142578 71 36 C 71 31.27458953857422 70.07475280761719 26.69105911254883 68.24993896484375 22.37673187255859 C 66.48716735839844 18.20906829833984 63.96340179443359 14.46591949462891 60.74874114990234 11.25125885009766 C 57.53408050537109 8.036598205566406 53.79093170166016 5.512832641601562 49.62326812744141 3.75006103515625 C 45.30894088745117 1.925247192382812 40.72541046142578 1 36 1 M 36 0 C 55.88224792480469 0 72 16.11774826049805 72 36 C 72 55.88224792480469 55.88224792480469 72 36 72 C 16.11774826049805 72 0 55.88224792480469 0 36 C 0 16.11774826049805 16.11774826049805 0 36 0 Z",
    stroke: "none",
    fill: "#adc927"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5952",
    "data-name": "Group 5952",
    transform: "translate(68.214 115.608)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_1",
    "data-name": "Union 1",
    d: "M1.187,33.16A1.185,1.185,0,0,1,0,31.976V29.608a1.185,1.185,0,0,1,1.187-1.184h33.2a1.185,1.185,0,0,1,1.186,1.184v2.368a1.185,1.185,0,0,1-1.186,1.184Zm1.186-4.737V8.29A8.3,8.3,0,0,1,10.671,0H24.9a8.3,8.3,0,0,1,8.3,8.29V28.423Z",
    transform: "translate(0)",
    fill: "#c7e64b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_2",
    "data-name": "Union 2",
    d: "M0,8.29A8.3,8.3,0,0,1,8.3,0H22.529a8.3,8.3,0,0,1,8.3,8.29,19.315,19.315,0,0,1,0,4.121c-.575,2.042-3.218,4.945-10.624,9.02A71.076,71.076,0,0,1,0,28.423Z",
    transform: "translate(2.372)",
    fill: "#abc73e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_3",
    "data-name": "Union 3",
    d: "M0,8.29A8.3,8.3,0,0,1,8.3,0H22.528a24.5,24.5,0,0,1-9.343,12.744A48.611,48.611,0,0,1,0,19.117Z",
    transform: "translate(2.372)",
    fill: "#869b34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M0,0H7.127V2.376A1.188,1.188,0,0,1,5.939,3.563H1.188A1.188,1.188,0,0,1,0,2.376Z",
    transform: "translate(4.418 33.22)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M0,0H7.127V2.376A1.188,1.188,0,0,1,5.939,3.563H1.188A1.188,1.188,0,0,1,0,2.376Z",
    transform: "translate(23.424 33.22)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M-287.658,450.03v-3.6s2.056-.035,3.613,0c1.568-.006,3.851,1.953,3.705,3.073a.554.554,0,0,1-.589.527Z",
    transform: "translate(290.059 -421.539)",
    fill: "#f3f1f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M-280.349,449.995v-3.7s-2.283-.035-3.84,0c-1.568-.006-3.851,1.953-3.705,3.073a.554.554,0,0,0,.589.527C-286.314,449.893-280.349,449.995-280.349,449.995Z",
    transform: "translate(313.561 -421.554)",
    fill: "#f3f1f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_35716",
    "data-name": "Group 35716",
    transform: "translate(89.76 113.973)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_448",
    "data-name": "Ellipse 448",
    cx: 4.567,
    cy: 4.567,
    rx: 4.567,
    ry: 4.567,
    transform: "translate(2.448 2.705)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-clock",
    "data-name": "Icon awesome-clock",
    d: "M7.576.563a7.013,7.013,0,1,0,7.013,7.013A7.012,7.012,0,0,0,7.576.563Z",
    transform: "translate(-0.563 -0.562)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49021",
    "data-name": "Path 49021",
    d: "M26.617,16.788a.857.857,0,0,1-.612-.257l-1.252-1.268a.884.884,0,0,1,0-1.239.857.857,0,0,1,1.223,0l.641.649,1.893-1.917a.857.857,0,0,1,1.223,0,.884.884,0,0,1,0,1.239l-2.5,2.536A.857.857,0,0,1,26.617,16.788Z",
    transform: "translate(-20.228 -7.631)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchooltrack1Svg);
export default __webpack_public_path__ + "static/media/schooltrack1svg.c2d83b8b715a12e5455186100679cb96.svg";
export { ForwardRef as ReactComponent };